import { GrillIcon } from './GrillIcon';

/**
 * author: Google
 * id 22C8B00E-9BA8-4C66-994B-A2F0B4D369DD
 * name grill
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grill.svg
 * tags
 * - Food / Drink 
 */
export const BarbecueIcon = GrillIcon;
export default BarbecueIcon